<!-- Change Password Component - Modern Bootstrap 5.3.7 -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
      
      <!-- Change Password Card -->
      <div class="card shadow-lg border-0 change-password-card">
        <div class="card-body p-4 p-md-5">
          
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="change-password-icon mb-3">
              <i class="fa fa-key fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold text-dark mb-1">
              {{ 'CHANGE_PASSWORD.TITLE' | translate }}
            </h2>
            <p class="text-muted small">
              {{ 'CHANGE_PASSWORD.SUBTITLE' | translate }}
            </p>
          </div>
          
          <!-- Change Password Form -->
          <form [formGroup]="changePasswordForm" (ngSubmit)="resetUserPassword()" novalidate>
            
            <!-- Email Field -->
            <div class="mb-3">
              <label for="username" class="form-label fw-semibold">
                <i class="fa fa-envelope me-2 text-muted"></i>
                {{ 'CHANGE_PASSWORD.EMAIL_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-envelope text-muted"></i>
                </span>
                <input 
                  formControlName="username"
                  type="email" 
                  class="form-control border-start-0 ps-0"
                  id="username" 
                  [placeholder]="'CHANGE_PASSWORD.EMAIL_PLACEHOLDER' | translate"
                  [class.is-invalid]="changePasswordForm.get('username')?.errors && changePasswordForm.get('username')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="username-error">
              </div>
              <div 
                id="username-error"
                class="invalid-feedback d-block"
                *ngIf="changePasswordForm.get('username')?.touched && changePasswordForm.get('username')?.hasError('required')">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'CHANGE_PASSWORD.EMAIL_REQUIRED' | translate }}
              </div>
            </div>
            
            <!-- Current Password Field -->
            <div class="mb-3">
              <label for="password" class="form-label fw-semibold">
                <i class="fa fa-lock me-2 text-muted"></i>
                {{ 'CHANGE_PASSWORD.CURRENT_PASSWORD_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-lock text-muted"></i>
                </span>
                <input 
                  formControlName="password"
                  type="password" 
                  class="form-control border-start-0 ps-0"
                  id="password" 
                  [placeholder]="'CHANGE_PASSWORD.CURRENT_PASSWORD_PLACEHOLDER' | translate"
                  [class.is-invalid]="changePasswordForm.get('password')?.errors && changePasswordForm.get('password')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="password-error">
              </div>
              <div 
                id="password-error"
                class="invalid-feedback d-block"
                *ngIf="changePasswordForm.get('password')?.hasError('required') && changePasswordForm.get('password')?.touched">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'CHANGE_PASSWORD.PASSWORD_REQUIRED' | translate }}
              </div>
            </div>
            
            <!-- New Password Field -->
            <div class="mb-3">
              <label for="newpassword" class="form-label fw-semibold">
                <i class="fa fa-key me-2 text-muted"></i>
                {{ 'CHANGE_PASSWORD.NEW_PASSWORD_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-key text-muted"></i>
                </span>
                <input 
                  formControlName="newpassword"
                  type="password" 
                  class="form-control border-start-0 ps-0"
                  id="newpassword" 
                  [placeholder]="'CHANGE_PASSWORD.NEW_PASSWORD_PLACEHOLDER' | translate"
                  [class.is-invalid]="changePasswordForm.get('newpassword')?.errors && changePasswordForm.get('newpassword')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="newpassword-error">
              </div>
              <div 
                id="newpassword-error"
                class="invalid-feedback d-block"
                *ngIf="changePasswordForm.get('newpassword')?.hasError('required') && changePasswordForm.get('newpassword')?.touched">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'CHANGE_PASSWORD.PASSWORD_REQUIRED' | translate }}
              </div>
            </div>
            
            <!-- Confirm New Password Field -->
            <div class="mb-4">
              <label for="confirmnewpassword" class="form-label fw-semibold">
                <i class="fa fa-check-circle me-2 text-muted"></i>
                {{ 'CHANGE_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-check-circle text-muted"></i>
                </span>
                <input 
                  formControlName="confirmnewpassword"
                  type="password" 
                  class="form-control border-start-0 ps-0"
                  id="confirmnewpassword" 
                  [placeholder]="'CHANGE_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                  [class.is-invalid]="changePasswordForm.get('confirmnewpassword')?.errors && changePasswordForm.get('confirmnewpassword')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="confirmnewpassword-error">
              </div>
              <div 
                id="confirmnewpassword-error"
                class="invalid-feedback d-block"
                *ngIf="changePasswordForm.get('confirmnewpassword')?.hasError('required') && changePasswordForm.get('confirmnewpassword')?.touched">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'CHANGE_PASSWORD.PASSWORD_REQUIRED' | translate }}
              </div>
              <!-- Password mismatch error -->
              <div 
                class="invalid-feedback d-block"
                *ngIf="changePasswordForm.get('confirmnewpassword')?.hasError('mismatch') && changePasswordForm.get('confirmnewpassword')?.touched">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'CHANGE_PASSWORD.PASSWORD_MISMATCH' | translate }}
              </div>
            </div>
            
            <!-- Change Password Button -->
            <div class="d-grid gap-2 mb-3">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg fw-semibold"
                [disabled]="!changePasswordForm.valid || processing"
                [attr.aria-label]="'CHANGE_PASSWORD.CHANGE_BUTTON' | translate">
                <span *ngIf="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <i *ngIf="!processing" class="fa fa-key me-2"></i>
                {{ 'CHANGE_PASSWORD.CHANGE_BUTTON' | translate }}
              </button>
            </div>
            
            <!-- Help Links -->
            <div class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                <a 
                  [routerLink]="['/login-help']"
                  class="text-decoration-none fw-semibold text-primary"
                  [attr.aria-label]="'CHANGE_PASSWORD.FORGOT_PASSWORD' | translate">
                  <i class="fa fa-question-circle me-1"></i>
                  {{ 'CHANGE_PASSWORD.FORGOT_PASSWORD' | translate }}
                </a>
                <span class="text-muted">|</span>
                <a 
                  [routerLink]="['/contact-us']"
                  class="text-decoration-none fw-semibold text-secondary"
                  [attr.aria-label]="'CHANGE_PASSWORD.NEED_HELP' | translate">
                  <i class="fa fa-life-ring me-1"></i>
                  {{ 'CHANGE_PASSWORD.NEED_HELP' | translate }}
                </a>
              </div>
            </div>
            
          </form>
          
          <!-- Back to Login -->
          <hr class="my-4">
          <div class="text-center">
            <p class="mb-2 text-muted small">{{ 'CHANGE_PASSWORD.REMEMBER_PASSWORD' | translate }}</p>
            <a 
              [routerLink]="['/login']"
              class="btn btn-outline-secondary fw-semibold"
              [attr.aria-label]="'CHANGE_PASSWORD.BACK_TO_LOGIN' | translate">
              <i class="fa fa-arrow-left me-2"></i>
              {{ 'CHANGE_PASSWORD.BACK_TO_LOGIN' | translate }}
            </a>
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</div>
